import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button", "cancel"]

  disconnect() {
    if (this.modalContainer) {
      delete this.modalContainer.dataset.preventClose;
    } else {
      const modal = this.element.closest('[data-controller="modal"]');
      if (modal) {
        delete modal.dataset.preventClose;
      }
    }
  }

  disable(event) {
    if (!this.hasButtonTarget) return;
    
    setTimeout(() => {
      const button = this.buttonTarget;
      const text = button.dataset.disableText;
      
      const clone = button.cloneNode(true);
      clone.disabled = true;
      clone.removeAttribute("data-disable-submit-target");
      
      if (text) {
        if (clone.tagName === 'INPUT') {
          clone.value = text;
        } else {
          clone.textContent = text;
        }
      }
      
      button.style.display = 'none';
      button.insertAdjacentElement('afterend', clone);

      // Prevent modal closing
      const modal = this.element.closest('[data-controller="modal"]');
      if (modal) {
        modal.dataset.preventClose = "true";
        this.modalContainer = modal;
      }

      // Disable interactions with the form
      this.element.classList.add("pointer-events-none", "opacity-75");

      if (this.hasCancelTarget) {
        this.cancelTargets.forEach((cancelBtn) => {
          cancelBtn.classList.add("opacity-50", "pointer-events-none");
          cancelBtn.disabled = true;
        });
      }
    }, 0);
  }
}
